import React from 'react';
import PreLoginPage from '../../views/core/PreLoginPage';
import '../../css/LoginForm.css';
import $ from 'jquery';

import { FormWithConstraints, FieldFeedback } from 'react-form-with-constraints';
import { FieldFeedbacks, FormGroup, FormControlInput } from 'react-form-with-constraints-bootstrap4';
import HmAjax from '../../util/HmAjax';
import UserStore from '../../util/UserStore';
import { isMobile, isTablet } from 'react-device-detect';
import BrowserStorageUtil from '../../util/BrowserStorageUtil';
import BrowserUtil from '../../util/BrowserUtil';
import loginIcon from '../../images/icons/loginicon.png';


class LoginForm extends PreLoginPage {

	constructor(props) {
		super(props);

		this.state = {
			plp_userinput: this.props.userid || "",
			password: '',     
			submitButtonDisabled: false,
			serverMessage: this.props.errMsg || "",
			source:"plp",
			loginType:this.props.loginType || "userid",
			userLoginAllowed:false
		};

		this.handleChange = this.handleChange.bind(this);
		this.userIdChange = this.userIdChange.bind(this);
		this.handlePasswordChange = this.handlePasswordChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.showforgotPwd = this.showforgotPwd.bind(this);
		this.showCreateAccount = this.showCreateAccount.bind(this);
		this.googleLogin = this.googleLogin.bind(this);

		this.myTrackerInstance = this.getTracker();
		
		this.navigationKey="PLP_Navigation";
		
		this.gaFrom = this.props.gaFrom;
		this.gasignin = " - Returning User";
		console.log("this.gaFrom:::::::::::",this.gaFrom);
		if(this.gaFrom == "Top" || this.gaFrom == "Bottom"){
			this.gaFrom = this.gaFrom+" Home - Join";
		}else{
			this.gaFrom = "Sign In - Users who have independently registered";
			this.gasignin = "";
		}
		console.log("this.gaFrom2222:::::::::::",this.gaFrom);
	}
	componentWillReceiveProps(nextProps) {
		//console.log('componentWillReceiveProps', nextProps);    
        this.setState({	
        	plp_userinput: nextProps.userid || "",
        	password: '',     
        	submitButtonDisabled: false,
        	serverMessage: "",
        	source:"plp",
        	loginType:nextProps.loginType || "userid"
        });
        
        this.gaFrom = nextProps.gaFrom;
        console.log("this.gaFrom:::::::::::",this.gaFrom);
        if(this.gaFrom == "Top" || this.gaFrom == "Bottom"){
        	this.gaFrom = this.gaFrom+" Home - Join";
        }else{
        	this.gaFrom = "Users who have independently registered - Sign Up";
        }

        console.log("this.gaFrom:::::::::::",this.gaFrom);
        
    }
    componentDidMount(){
    	this.sessionCheck();
    } 


    handleChange(e) {
    	const target = e.currentTarget;	
    	this.form.validateFields(target);

    	this.setState({
    		[target.name]: target.value,
    		submitButtonDisabled: !this.form.isValid()
    	});
    }

    userIdChange(e){
    	const target = e.currentTarget;

    	var phoneRegx = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;
    	if(phoneRegx.test(target.value)){
    		this.setState({loginType:"mobile", serverMessage: ""});
    	}else{
    		this.setState({loginType:"email", serverMessage: ""});
    	}
    	this.handleChange(e);
    }

    handlePasswordChange(e) {    
    	this.handleChange(e);
    }

    hmNav = function(userobj){

		/*if(this.props.liveFeed == "true" || this.props.liveFeed == true){
			window.top.location.href = "/";
			return;
		}*/		
		//console.log("this.props.navigateURL::::"+this.props.navigateURL);
		if(this.props.navigateURL == "/product-details"){
			window.top.location.href = this.props.navigateURL;
		}else{			
			if(this.productsAvailableToAccess(userobj)){				
				window.top.location.href = "/landing";
			}else{
				window.top.location.href = this.props.navigateURL;
			}
		}
		
	}

	productsAvailableToAccess(userobj){
		var user = userobj;
		//console.log("user::::",user);
		if(user != null){
			var permissions = user.entlHistory;//console.log("permissions:::",permissions);
			if(permissions != null && Object.keys(permissions).length > 0){
				for(var i in permissions){
					if(permissions[i] != null){
						var totalLevel = permissions[i].split(",").reduce(function(a,b){
							try{
								return parseInt(a) + parseInt(b);
							}catch(e){
								return 0;
							}
						});

						if(totalLevel > 0){
							return true;
						}
					}
				}
			}
		}

		return false;
	}

	storeRedirectUrl(){
		let redirectUrl = null;
		if(BrowserUtil.getCookie("loginSrc") && BrowserUtil.getCookie("loginSrc").length > 10){
			redirectUrl = (BrowserUtil.getCookie("loginSrc")).replace(/"/g,"");
		}

		if(redirectUrl){
			BrowserStorageUtil.storeItem("loginSrc", redirectUrl);
		}
	}
	
	submitForm = function(){
		var formData = {
			"userId":this.state.plp_userinput,
			"password":this.state.password
		}
		
		
		var me =this;
		me.setState({submitButtonDisabled: true});

		
		var callBackSuccess = function(response){
			if(response !== null){
				if(response.authenticated){
					console.log("response : ", response);
					//Setting user object at the browser level
					new UserStore().store(response.user);
					
					me.storeRedirectUrl();

					try{
						me.doLumosLogout();
					}catch(e){}
					me.setState({submitButtonDisabled: false});
					try{						
						var userObj = response.user;
						var loginObj = {
							"user_id" : (userObj == null) ? "" : userObj.userId,
							"login_id" : me.state.plp_userinput,
							"user_agent" : navigator.userAgent,
							"platform" : navigator.platform,
							"device" : isMobile ? "mobile" : (isTablet ? "tablet" : "PC"),
							"ip_address" : "ip_address",
							"result" : true,
							"session_id" : (userObj == null) ? "" : userObj.authToken
						}
						
						me.storeTrackEvent("login", loginObj);
					}catch(e){}
					

					if(!me.tracked){
						me.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"logged-in"});
						me.tracked = true;
					}

					/*setTimeout(function(){
						//me.trackMe(true,response.user);
						me.hmNav(response.user);
					},200);*/
					me.hmNav(response.user);
					
					
				}else{
					if(response.message == "provider_forbidden"){						
						me.setState({submitButtonDisabled: false, serverMessage: me.rb("google.errmsg.login")});
					}else{					
						me.setState({ submitButtonDisabled: false, serverMessage: me.rb(response.message)});
					}
					//me.showAlert(me.rb("alert"),me.rb(response.message));
					me.trackMe(false);
				}
			}

			
		}

		var callBackFailure = function(response){

			console.log("response : ", response);
			me.trackMe(false);
			me.setState({submitButtonDisabled: false});
		}

		new HmAjax(this.getUrlFor("LOGIN"),formData).post(callBackSuccess,callBackFailure);
		new UserStore().clearOldUser();
	}
	getUserStatus(){

		if(this.state.plp_userinput.length<=0){
			return;
		}
		
		var formData = {
			"verificationId":this.state.plp_userinput
		}

		var me =this;
		var callBackSuccess = function(response){
			if(response !== null){
				console.log("response : ", response,"me.props.from:::",me.props.from);					
				if(response.user_exists){			
					me.setState({userLoginAllowed:true});
				}else{
					if(response.message == "provider_forbidden"){						
						me.setState({submitButtonDisabled: false, serverMessage: me.rb("google.errmsg.login")});
					}else{					
						//me.setState({userLoginAllowed:false});
						//me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);
						me.checkValidUserInput();
					}					
				}
			}

			
		}

		var callBackFailure = function(response){
			console.log("response : ", response);	
			me.setState({submitButtonDisabled: false});
		}

		new HmAjax(this.getUrlFor("GET_USER_STATUS")+this.state.loginType,formData).post(callBackSuccess,callBackFailure);
		
	}
	checkValidUserInput(){
		var me = this;
		var userinput = this.state.plp_userinput;
		var phoneRegx = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;
		
		if(phoneRegx.test(userinput)){			
			if(userinput.length == 10){				
				me.setState({userLoginAllowed:false});
				me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);
			}else{
				me.setState({submitButtonDisabled: false, serverMessage: me.rb("login.invalidinput.msg")});
			}
		}else{
			if(userinput.match(/^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/)){
				me.setState({userLoginAllowed:false});
				me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);
			}else{
				me.setState({submitButtonDisabled: false, serverMessage: me.rb("login.invalidinput.msg")});
			}
		}
	}
	doLumosLogout(){
		var me = this;
		console.log("logout url="+me.getUrlFor("LUMOS_LOGOUT"));
		$.ajax({
			url: me.getUrlFor("LUMOS_LOGOUT"),	            
			type: 'GET',
			xhrFields: {
				withCredentials: true
			},
			crossDomain: true,
			success: function(response){	            	

			},
			error: function(response){
				console.log("Error in LUMOS_LOGOUT",response);
			}
		});
	}
	handleSubmit(e) {
		e.preventDefault();

		this.form.validateFields();

		this.setState({ submitButtonDisabled: !this.form.isValid() });

		if (this.form.isValid()) {   

			if(this.state.userLoginAllowed){
				this.submitForm();  
			}else{
				this.getUserStatus();
			}


		}
	}
	
	trackMe(result,userObj=null){		
		var trackObj = {
			"user_id" : (userObj == null) ? "" : userObj.userId,
			"login_id" : this.state.plp_userinput,
			"user_agent" : navigator.userAgent,
			"platform" : navigator.platform,
			"device" : isMobile ? "mobile" : (isTablet ? "tablet" : "PC"),
			"ip_address" : "ip_address",
			"result" : (result === true),
			"session_id" : (userObj == null) ? "" : userObj.authToken
		}

		this.initiateTrack("login",trackObj);
	}
	showCreateAccount(){
		if(!this.tracked){
			this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"signin-signup"});
			this.tracked = true;
		}

		this.props.callbackCreateAccount(this.props.navigateURL,this.props.freetrail);
	}
	showforgotPwd(){
		this.props.callbackForgotPwd(this.state.source);
	}
	googleLogin(){
		if(!this.tracked){
			this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"signin-googlesignin"});
			this.tracked = true;
		}

		var navigateObj = {
			navigateURL:this.props.navigateURL
		}
		BrowserStorageUtil.storeSessionItem(this.navigationKey, JSON.stringify(navigateObj));
		
		window.top.location.href = this.getUrlFor("GOOGLE_LOGIN_API");
	}
	render() {
		if(this.state.loggedIn){
			return super.render();
		} else { return (
			<div className="row nomargin loginParent">
			<div className="col-sm-4 nopadding loginLeftSection">
			<h1 className="loginLeftContent">{this.rb("signincaptital")}</h1>
			<div className="charactercontainer d-none d-sm-block">
			<img className="charactericons loginIcon" src={loginIcon} />
			</div>
			</div>


			<div id="loginRoot" className="plpLogin col-sm-8">

			<div className="container">

			<div className="row">
			<div className="col-md-12">

			<div className="row">
			<div className="col-md-12 mx-auto nopadding">
			<div className="rounded-0">

			<div className="text-center ">

			<FormWithConstraints ref={formWithConstraints => this.form = formWithConstraints}
			onSubmit={this.handleSubmit} noValidate>

			<FormGroup for="plp_userinput">
			{( () => {
				/* if(this.state.loginType == "mobile"){
					return (
						<span className="countrycode">+91</span>
						);
					} */
				})()}

				<FormControlInput type="plp_userinput" className={"plp_userinput "+this.state.loginType} name="plp_userinput" placeholder={this.rb("login.userplaceholder")}
				value={this.state.plp_userinput} onChange={this.userIdChange}
				required minLength={1} maxLength={254} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="3"/>

				<FieldFeedbacks for="plp_userinput">
				<FieldFeedback when="valueMissing">{this.rb("login.useridrequired")}</FieldFeedback>
				<FieldFeedback when="*" />
				</FieldFeedbacks>
				</FormGroup>


				{( () => {
					if(this.state.userLoginAllowed){
						return (
							<div>
							<FormGroup for="password">		
							<FormControlInput type="password" className="password" name="password" placeholder={this.rb("login.password")}
							innerRef={password => this.password = password}
							value={this.state.password} onChange={this.handlePasswordChange}
							required minLength={1} maxLength={50} tabIndex="4"/>
							<FieldFeedbacks for="password" show="all">
							<FieldFeedback when="valueMissing">{this.rb("login.pwdrequired")}</FieldFeedback>
							</FieldFeedbacks>
							</FormGroup>
							<div className="text-right forgotPassword josefinsansFont" onClick={this.showforgotPwd}>
							{this.rb("forgot_password")}
							</div>
							</div>
							);
						}
					})()}




					<div className="server-messages">{this.state.serverMessage}</div>

					<button disabled={this.state.submitButtonDisabled} className="submitButton">{this.rb("signin")}</button>
					</FormWithConstraints>	
					</div>
					</div>
					</div>


					</div>

					</div>
					</div>
					</div>

					<div className="mt-20 pt-10">                         
				{/*<hr className="hr-text" data-content="OR" />*/}
				<div class="text-center josefin">OR</div>
				<div className="socialLoginContainer text-center">                                       
				<div className="socialLoginButtons google" onClick={this.googleLogin}>
				<i className="fab fa-google"></i>
				{this.rb("login.continuegoogle")}
				</div>
				</div>
				</div>

				<div className="mt-20 text-center">
				<div className="infogrey">
				{this.rb("register.donthaveaccount")}
				</div>
				<div className="text-center loginCreateNewAccount josefinsansFont" onClick={this.showCreateAccount}>
				{this.rb("login.createnewaccount")}
				</div>
				</div>




				</div>
				</div>
				);}
			}
		}

		export default LoginForm;



// WEBPACK FOOTER //
// ./src/views/login/LoginForm.js